import { render, staticRenderFns } from "./ProprietaireActuel.vue?vue&type=template&id=6c2c4aa6&"
import script from "./ProprietaireActuel.vue?vue&type=script&lang=js&"
export * from "./ProprietaireActuel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProprietaireActuel.vue"
export default component.exports